
import { PropType, defineComponent } from 'vue'

export default defineComponent({
    props: {
        startColor: {
            type: String as PropType<string>,
            default: () => '#ECCF8B'
        },
        endColor: {
            type: String as PropType<string>,
            default: () => '#A28442'
        }
    }
})
